// extracted by mini-css-extract-plugin
export default {"container":"ckHV4G","grid":"htcADB","column":"GLWhGq","row":"DXT5mJ","responsive":"zKtt5A"};